import React from "react";
import { Organization, Team, User } from "../../../types/userTypes";
import Box from "@mui/material/Box";
import Grid from "@mui/material/Grid"; // Utilizza Grid come richiesto
import TextField from "@mui/material/TextField";
import CustomAutoComplete from "../CommonComponents/CustomAutoComplete";
import Button from "@mui/material/Button";
import {Alert, FormControl, Tooltip} from "@mui/material";
import { Competition } from "../../../types/eventTypes";
import {PANEL_BUTTON_HEIGHT} from "../../../constants/styles";
import CancelIcon from "@mui/icons-material/Close";
import SaveIcon from "@mui/icons-material/Save";
import TeamSearch from "../../../pages/custom-components/CommonComponents/SearchAutocomplete/TeamSearch";

interface OrganizationFormProps {
    organization: Organization;
    competitions: Competition[];
    sendFormLabel?: string;
    users: User[];
    onSubmit: () => void;
    onFieldChange: (fieldName: keyof Organization, value: string | Competition[] | User[] | Team[]) => void;
    onCloseClick: () => void
}

const OrganizationForm: React.FC<OrganizationFormProps> = ({
                                                               onFieldChange,
                                                               organization,
                                                               onSubmit,
                                                               users,
                                                               competitions,
                                                               sendFormLabel = 'Send Form',
                                                                onCloseClick
                                                           }) => {

    const [orgMessage, setOrgMessage] = React.useState<string>("");

    function handleInputChange(e: React.ChangeEvent<HTMLInputElement>) {
        onFieldChange("name", e.target.value);
    }

    function handleMultiSelectionChange(name: keyof Organization, selection: any[]) {
        const userArray: string[] = [];

        if (name === 'users') {
            selection.forEach(user => {
                if (user.organizations?.[0]) {
                    if (user.organizations[0].name !== organization.name) {
                        userArray.push(user.email);
                    }
                }
            });

            if (userArray.length > 0) {
                setOrgMessage(
                    "Warning you will overwrite the organization of the following users: " +
                    userArray.join(', ')
                );
            } else {
                setOrgMessage("");
            }
        }
        onFieldChange(name, selection);
    }

    function handleOnSubmit(e: React.FormEvent<HTMLFormElement>) {
        e.preventDefault();
        onSubmit();
    }

    return (
        <Box
            component="form"
            onSubmit={handleOnSubmit}
        >
            {orgMessage !== "" && (
                <Alert variant="filled" severity="warning" sx={{marginBottom: 3}}>
                    {orgMessage}
                </Alert>
            )}

            <Grid
                container
                spacing={2}
                sx={{ marginBottom: 3, marginTop: 1 }}
            >
                <Grid size={{ xs: 12, md: 6, lg: 6 }}>
                    <TextField
                        label="Name"
                        onChange={handleInputChange}
                        value={organization.name}
                        name="name"
                        placeholder="Name"
                        type="text"
                        variant="outlined"
                        required={true}
                        fullWidth
                        size="medium"
                    />
                </Grid>
                <Grid size={{ xs: 12, md: 6, lg: 6 }}>
                    <CustomAutoComplete
                        onChange={(_: any, newValue: any) => handleMultiSelectionChange("competitions", newValue)}
                        value={organization.competitions}
                        label="Competitions"
                        name="competitions"
                        options={competitions}
                        labelField="name"
                        valueField="id"
                    />
                </Grid>
                <Grid size={{ xs: 12, md: 6, lg: 6 }}>
                    <CustomAutoComplete
                        onChange={(_: any, newValue: any) => handleMultiSelectionChange("users", newValue)}
                        value={organization.users}
                        label="Users"
                        name="users"
                        options={users}
                        labelField="email"
                        valueField="id"
                    />
                </Grid>
                <Grid size={{ xs: 12, md: 6, lg: 6 }}>
                    <FormControl fullWidth>
                        <TeamSearch
                            value={organization.teams}
                            onChange={ teams => handleMultiSelectionChange("teams", teams)}
                            freeSolo={false}
                            disabled={organization.competitions.length <= 0}
                            multiple={true}
                            label={"Teams"}
                        />
                    </FormControl>

                    {/*<CustomAutoComplete
                        onChange={(_: any, newValue: any) => handleMultiSelectionChange("teams", newValue)}
                        value={organization.teams}
                        label="Teams"
                        freeSolo={true}
                        disabled={organization.competitions.length <= 0}
                        name="teams"
                        options={teams}
                        labelField="name"
                        valueField="id"
                    />*/}
                </Grid>
            </Grid>

            <Box width="100%" display="flex" alignItems="center" justifyContent="flex-end">
                <Tooltip
                    title="Competition must be filled"
                    disableHoverListener={!(organization.competitions?.length === 0)}
                >
                    <Box display="flex" gap={1}>
                        <Button
                            disabled={organization.competitions?.length === 0}
                            variant="contained"
                            type="submit"
                            sx={ { width: '190px', height: PANEL_BUTTON_HEIGHT } }
                            startIcon={<SaveIcon />}
                        >
                            {sendFormLabel}
                        </Button>
                        <Button
                            onClick={onCloseClick}
                            disabled={organization.competitions?.length === 0}
                            variant="contained"
                            type="submit"
                            sx={ { width: '190px', height: PANEL_BUTTON_HEIGHT } }
                            startIcon={<CancelIcon />}
                        >
                            Close
                        </Button>
                    </Box>
                </Tooltip>
            </Box>
        </Box>
    );
};

export default OrganizationForm;